import palette from './01Colors/palette-dm-web';
import typography from './02Typography/typography-dm';
import dimension from './03Dimensions/dimensions-dm-web';
import breakpoints from './04MediaQueries/breakpoints-dm';
import ratio from './04MediaQueries/ratio-dm';
import radius from './06Shapes/radii-dm';
import ThemePropsWeb from './ThemeProps';

const theme: ThemePropsWeb = {
  breakpoints,
  dimension,
  palette,
  radius,
  ratio,
  typography,
};

export default theme;
